import type { MonthRangePickerProps } from "./types-month-range-picker";
import { useMonthRangePicker } from "./use-month-range-picker";
import { MonthRangePickerView } from "./view-month-range-picker";

/**
 * Seletor de intervalo de meses (Figma "Month Range Dual"): botão com o rótulo `mmm/aaaa – mmm/aaaa` e painel com
 * dois anos lado a lado. O Prime não tem esse componente; a View só repassa o que o ViewModel calcula.
 */
export function MonthRangePicker(props: MonthRangePickerProps) {
  const viewModel = useMonthRangePicker(props);

  return <MonthRangePickerView {...viewModel} />;
}
MonthRangePicker.displayName = "MonthRangePicker";
